import { LauraSAISettings } from "@/app/components/laura/LauraSAISettings";

export default function AccountLauraPage() {
    return <LauraSAISettings />;
}
